import { render, staticRenderFns } from "./mdnav.vue?vue&type=template&id=0d1228b4"
import script from "./mdnav.vue?vue&type=script&lang=js"
export * from "./mdnav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports